function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_17_automated_thumbnail_generation_svg__cls-1{fill:#81858d}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon_17_automated_thumbnail_generation_svg__icon_17_automated_thumbnail_generation"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_17_automated_thumbnail_generation_svg___\\u043B\\u043E\\u0439_54"
}, /*#__PURE__*/React.createElement("path", {
  className: "icon_17_automated_thumbnail_generation_svg__cls-1",
  d: "M12.54 20l-3.42-4.2.51-.4 3.41 4.2-.5.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_17_automated_thumbnail_generation_svg__cls-1",
  d: "M6.21 20l-.5-.4 3.41-4.2.51.4L6.21 20z"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon_17_automated_thumbnail_generation_svg__cls-1",
  d: "M13.16 16.1H6.21a2.4 2.4 0 01-2.41-2.39v-1.77H0v-1.29a2.4 2.4 0 012.41-2.39h10.75a2.4 2.4 0 012.41 2.39v3.06a2.4 2.4 0 01-2.41 2.39zM16.95 13.71v-3.06l4.49-1.09c.7-.23 1.56.06 1.56.54v4.16c0 .47-.86.77-1.56.54l-4.49-1.09z"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "icon_17_automated_thumbnail_generation_svg__cls-1",
  cx: 12.96,
  cy: 3.4,
  rx: 3.43,
  ry: 3.4
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "icon_17_automated_thumbnail_generation_svg__cls-1",
  cx: 4.32,
  cy: 3.4,
  rx: 3.43,
  ry: 3.4
})));

var SvgIcon17Automatedthumbnailgeneration = function SvgIcon17Automatedthumbnailgeneration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_17_automated_thumbnail_generation_svg___024_Q1",
    viewBox: "0 0 23 20"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJfMDI0X1ExIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMyAyMCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM4MTg1OGQ7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJpY29uXzE3X2F1dG9tYXRlZF90aHVtYm5haWxfZ2VuZXJhdGlvbiI+PGcgaWQ9Il/Qu9C+0LlfNTQiPjxnPjxnPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxMi41NCAyMCA5LjEyIDE1LjggOS42MyAxNS40IDEzLjA0IDE5LjYgMTIuNTQgMjAiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNi4yMSAyMCA1LjcxIDE5LjYgOS4xMiAxNS40IDkuNjMgMTUuOCA2LjIxIDIwIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMuMTYsMTYuMUg2LjIxYy0xLjMzLDAtMi40MS0xLjA3LTIuNDEtMi4zOXYtMS43N0gwdi0xLjI5YzAtMS4zMiwxLjA4LTIuMzksMi40MS0yLjM5SDEzLjE2YzEuMzMsMCwyLjQxLDEuMDcsMi40MSwyLjM5djMuMDZjMCwxLjMyLTEuMDgsMi4zOS0yLjQxLDIuMzlaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTYuOTUsMTMuNzF2LTMuMDZsNC40OS0xLjA5Yy43LS4yMywxLjU2LC4wNiwxLjU2LC41NHY0LjE2YzAsLjQ3LS44NiwuNzctMS41NiwuNTRsLTQuNDktMS4wOVoiLz48L2c+PGVsbGlwc2UgY2xhc3M9ImNscy0xIiBjeD0iMTIuOTYiIGN5PSIzLjQiIHJ4PSIzLjQzIiByeT0iMy40Ii8+PGVsbGlwc2UgY2xhc3M9ImNscy0xIiBjeD0iNC4zMiIgY3k9IjMuNCIgcng9IjMuNDMiIHJ5PSIzLjQiLz48L2c+PC9nPjwvZz48L3N2Zz4=";
export { SvgIcon17Automatedthumbnailgeneration as ReactComponent };